<template>
  <div class="header clearfix">
    <div class="logo">
      <router-link to="/">
        <!-- <div class="logo_img"></div> -->
        <el-image :src="require('@/assets/logo.png')" fit="scale-down"></el-image>
      </router-link>
    </div>
    <div class="rep_search">
      <div :class="['clearfix','search_bg',{'search_focus': show === true}]">      
        <div style="display:flex;">
           <div>
            <input class="input_text"
                  autocomplete="off"
                  v-model="input"
                  ref="input_text"
                  type="text"
                  @focus="show = true"
                  @blur="show = false"
                  @keyup.enter="toSearch"
                  placeholder="请输入产品编码，CAS编码，关键字或结构式查询"/>
          </div>
          <div style="display: flex;align-items: center;">
            <div class="btn_search" @click="toSearch" style="display: flex;align-items: center;justify-content: center;">
              <!-- <el-icon color="#fff"><Search /></el-icon> -->
               <img src="@/assets/icon/search (2).png" alt="" style="width:35px;margin-right:5px">
            </div>
          </div> 
        </div>
      
        <!-- <div v-if="$route.matched[0].path !== '/shandongSearch/:id?'" class="drop_down">
          <transition name="el-fade-in-linear">
            <div class="dropDownContain" v-show="show">
              <div class="down_left">结构式查询请点击右边产品结构查询</div>
              <div class="down_right">
                <ul>
                  <li @click="toAdvsearch('advsearch')">产品结构搜索</li>
                  <li @click="toAdvsearch('coa')">CoA搜索(质检证书)</li>
                  <li @click="toAdvsearch('msds')">MSDS 搜索</li>
                  <li @click="toAdvsearch('productlines')">产品线搜索</li>
                  <li @click="toAdvsearch('sosearch')">订单发货查询</li>
                </ul>
              </div>
            </div>
          </transition>
        </div> -->
      </div>
    </div>
    <div class="logos" style="display: flex;align-items: center;">
      <img src="@/assets/icon/user-19.png" style="width:35px;cursor: pointer;" @click="router.push('/profileInfo')" alt="">
      <img src="@/assets/icon/tel.png" style="width:160px;margin-bottom:3px"  alt="">
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { trim } from 'core-js/internals/string-trim'
import { Search } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
const input = ref('')
const show = ref(false)
const isReads = ref(0)
const router = useRouter()
const route = useRoute()
const token = ref('')
// 搜索框搜索函数
const toSearch = () => {
  input.value = trim(input.value)
  show.value = false
  if (input.value.length === 0 || input.value.split(" ").join("").length === 0) {
    return false
  } else {
      router.push('/search/' + encodeURIComponent(input.value))
  }
  // 利用变量判断是否重复搜索开始
  if (input.value === input.value) {
    isReads.value++
  }
  if (isReads.value === 2 && input.value !== '') {
    router.push('/search/' + encodeURIComponent(input.value) + ' ')
    isReads.value = 0
  }
  // 利用变量判断是否重复搜索结束
}

onMounted(() => {
  if (route.params.fruitKey) {
    input.value = trim(decodeURIComponent(route.params.fruitKey as string))
  }
})

// 组件创建时的逻辑
// if (route.params.id) {
//   input.value = trim(decodeURIComponent(route.params.id as string))
// }

// 监听路由变化
watch(() => route.path, (newVal) => {
  const result = newVal.split('/')
  let finilly = result[2] && result[2].includes('.html') ? result[2].split('.html')[0] : result[2]
  if (result[1] !== 'search') {
    input.value = ''
  } else {
    input.value = decodeURIComponent(finilly)
  }  
  token.value = localStorage.getItem('MklUserToken') ? localStorage.getItem('MklUserToken') : ''
})
</script>

<style scoped>
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}

.header {
  width: 1200px;
  margin: auto;
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  width: 280px;
}
.logos {
  width: 175px;
}

.logo_img {
  background: url(@/assets/logo.png) no-repeat;
  background-size: 100% 98%;
  width: 259px;
  height: 82px;
}

.rep_search {
  padding-right: 30px;
  width:630px
}

.pic_hotline {
  width: 175px;
  display: flex;
  justify-content: flex-end;
}

.search_bg {
   position: relative;
     background: white;
  box-shadow: none !important;
  background: 
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(30deg, #0066BA, #00B4DB) border-box;
  border: 2px solid transparent;
  border-top-right-radius: 20px !important;
  background-origin: border-box;
}



/* .search_focus {
  border: 2px solid #0066BA;
} */


.search_bg input {
  background: none;
  outline: none;
  border: none;
  width: 553px;
  line-height: 36px;
  font-size: 14px;
  padding-left: 8px;
}

.search_bg div {
  float: left;
}

.btn_search {
  cursor: pointer;
}

.search_bg .drop_down {
  position: absolute;
  width: 100%;
  top: 38px;
  left: 0;
  z-index: 6;
}

.search_bg .drop_down .dropDownContain {
  width: 480px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  padding: 20px;
  box-sizing: border-box;
}

.search_bg .drop_down .dropDownContain div {
  width: 50%;
  color: #606266;
  font-size: 14px;
  box-sizing: border-box;
  line-height: 1.5rem;
}

.search_bg .drop_down .dropDownContain .down_left {
  padding-right: 20px;
}

.search_bg .drop_down .dropDownContain .down_right {
  padding-left: 20px;
  border-left: 1px solid #C0C4CC;
  color: #303133;
}

.search_bg .drop_down .dropDownContain .down_right ul li:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #0066BA;
}
</style>